import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardFilterBar } from '@/features/dashboard-filters';
import { useHeaderFilters } from '@/features/header-filters';

import { useTransportOverview } from '../lib/use-transport-overview';
import { TransportOverviewPage } from './transport-overview-page';

/**
 * Hands the transport filters to the shared header panel, leaving the page to its
 * stats and charts. Filters apply as they change, so the panel's Apply only
 * closes it.
 */
export function TransportOverviewWithFilters() {
  const { t } = useTranslation();
  const { setFilterConfig } = useHeaderFilters();
  const transport = useTransportOverview();

  const {
    urlState,
    vehicleCategories,
    updateOption,
    handleDateRangeChange,
    activeFilters,
    activeFiltersCount,
    hasActiveFilters,
    resetFilters,
    projectId,
    siteId
  } = transport;

  useEffect(() => {
    setFilterConfig({
      id: 'transport-overview-filters',
      title: t('report.transport.overview.title', 'Transport Overview'),
      content: (
        <DashboardFilterBar
          variant="transport"
          options={urlState}
          onOptionChange={updateOption}
          onDateRangeChange={handleDateRangeChange}
          resetKey={`${projectId}-${siteId}`}
          vehicleCategories={vehicleCategories}
        />
      ),
      activeCount: activeFiltersCount,
      activeFilters,
      onReset: resetFilters,
      onClearAll: resetFilters,
      isResetDisabled: !hasActiveFilters
    });
  }, [
    urlState,
    vehicleCategories,
    updateOption,
    handleDateRangeChange,
    activeFilters,
    activeFiltersCount,
    hasActiveFilters,
    resetFilters,
    projectId,
    siteId,
    setFilterConfig,
    t
  ]);

  return <TransportOverviewPage transport={transport} />;
}
